/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProviderResponse
 */
export interface ProviderResponse {
    /**
     * 
     * @type {string}
     * @memberof ProviderResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderResponse
     */
    label?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderResponse
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderResponse
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderResponse
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderResponse
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderResponse
     */
    effective?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderResponse
     */
    enabled?: boolean;
}

export function ProviderResponseFromJSON(json: any): ProviderResponse {
    return ProviderResponseFromJSONTyped(json, false);
}

export function ProviderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'effective': !exists(json, 'effective') ? undefined : json['effective'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function ProviderResponseToJSON(value?: ProviderResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'label': value.label,
        'isActive': value.isActive,
        'disabled': value.disabled,
        'allowEdit': value.allowEdit,
        'deleted': value.deleted,
        'effective': value.effective,
        'enabled': value.enabled,
    };
}


